module.exports = __webpack_public_path__ + "assets/img/close-circle@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/close-circle@2x.png
// module id = 1933
// module chunks = 0